export default __webpack_public_path__ + "static/media/arrowDownIcon.1b92da0e.svg";